export { CUSTOM_PRODUCT_ID, CUSTOM_SUPPLIER_ID } from '../libs/recommendations/constants'
export {
  isRequired,
  isRequiredForAccessApproverAccessTypes,
  isRequiredForCustomProduct,
  isRequiredForExternalEmail,
  isRequiredForUrlAccessTypes,
  isRequiredForWorkflowAccessType,
  isCategoryIdsValid,
  type Validators,
  customProductBrandId,
} from '../libs/productCatalogue/shared/validators'
export { requiredAccessApproverAccessTypes } from '../libs/productCatalogue/shared/validators'
export type {
  LinkOrgDataToBrandsResponse,
  LinkOrgDataToBrandsRequest,
} from '../lambdas/linkOrgDataToBrands/linkOrgDataToBrandsSchema'
export type { ProductBrand } from '../lambdas/listProductBrandCandidates/listProductBrandCandidatesSchema'
export type { UpdateProductBrandInput } from '../lambdas/updateProductBrand/updateProductBrandSchema'
export type {
  InsertProductCatalogueEntryInput,
  ProductCatalogueEntry,
  ProductCatalogueAccessType,
} from '../lambdas/insertCatalogueEntry/insertCatalogueEntrySchema'
export type { ListProductBrandsResponse } from '../lambdas/listProductBrands/listProductBrandsSchema'
export type { ProductCatalogueImportRecord } from '../lambdas/bulkUploadCatalogueEntry/bulkUploadCatalogueItemsSchema'
export type { AlternativeFeedbackRequest } from '../lambdas/alternativeFeedback/alternativeFeedbackSchema'
export type { SyncProductSupplierCategoriesInput } from '../lambdas/syncProductSupplierCategories/syncProductSupplierCategoriesSchema'
export type {
  GlobalProduct,
  Product,
  ProductWithSupplier,
  GlobalSupplier,
  Supplier,
  Subsidiary,
} from '../lambdas/searchProducts/searchProductsSchema'
export type { UpdateProductInput, UpdateProductResponse } from '../lambdas/updateProduct/updateProductSchema'
export type { UnarchiveProductResponse } from '../lambdas/unarchiveProduct/unarchiveProductSchema'
export type { InsertProductResponse, InsertProductInput } from '../lambdas/insertProduct/insertProductSchema'
export type { ArchiveProductResponse } from '../lambdas/archiveProduct/archiveProductSchema'
export type { GetProductEngagementsResponse } from '../lambdas/getProductEngagements/getProductEngagementsSchema'
export type { ProductDetails } from '../libs/products/schemas/productDetailsSchema'
export type { SupplierProductBrand } from '../libs/productCatalogue/shared/supplierProductBrandSchema'
